export enum UnitsFilterType {
  UnitPrice = 'UnitPrice',
  LivingArea = 'LivingArea',
  FloorSelection = 'FloorSelection',
  BedroomsCount = 'BedroomsCount',
  Status = 'Status',
};